import { useEffect } from "react";
import { PageHeader, PageWrapper } from "../../styles/page";
import { useEventHook } from "./hook";
import {
  EventBannerWrapper,
  EventDetailWrapper,
  EventInfoDescription,
  EventInfoNotice,
  EventInfoNoticeWrapper,
  EventInfoUserWrapper,
  EventInfoWrapper,
  EventPrizeCircle,
  EventPrizeItem,
  EventPrizeWrapper,
  EventUser,
  EventUserList,
  EventWrapper,
} from "./style";
import { PaginationWrapper } from "../../component/CommonTable";
import Pagination from "../../component/Pagination";

const Event = () => {
  const {
    users,
    getLikes,
    isCheck,
    currentPage,
    totalPages,
    paginatedList,
    handlePageChange,
  } = useEventHook();

  useEffect(() => {
    getLikes();
  }, []);
  return (
    <PageWrapper>
      <PageHeader>러너러너 제휴점 리워드 이벤트</PageHeader>
      <EventWrapper>
        <EventDetailWrapper>
          <EventBannerWrapper>
            <div className="title">
              <span>프리미엄 서비스 제휴 매장을 위한</span>
              <br />
              이벤트를 진행합니다.
            </div>
            <img src="/image-web/event/gift.png" />
          </EventBannerWrapper>
          <EventInfoWrapper>
            <EventInfoNoticeWrapper>
              <EventInfoDescription>
                <div className="item">
                  <img src="/image-web/event/check.png" />
                  <div>프리미엄 서비스 가입 홀덤펍 대상 이벤트입니다.</div>
                </div>
                <div className="item">
                  <img src="/image-web/event/check.png" />
                  <div>러너러너 앱에서 매장 검색후 " ♥ 즐겨찾기 “ 추가하기</div>
                </div>
                <div className="item">
                  <img src="/image-web/event/check.png" />
                  <div>♥ 즐겨찾기 인원수에 따라 달성 구간의 상품 1회 제공</div>
                </div>
                <div className="item">
                  <img src="/image-web/event/check.png" />
                  <div>
                    러너러너 담당자가 제휴 매장 오픈채팅방에 하루 1회 이벤트를
                    안내합니다.
                  </div>
                </div>
              </EventInfoDescription>
              <EventInfoNotice>
                <div className="title">주의사항</div>
                <div className="notice">
                  <p>
                    *프리미엄 서비스 유지 기간 동안 이벤트 내용이 적용됩니다.
                  </p>
                  <p>*휴대폰 개인 인증한 회원만 즐겨찾기 가능합니다.</p>
                  <p>
                    *부정한 방법으로 참여 했을 경우 이벤트 대상에서 제외됩니다.
                  </p>
                  <p>*서비스 해지 후 재가입 시, 리워드 횟수는 유지됩니다.</p>
                  <p>
                    *본 이벤트는 당사 사정에 의해 사전 공지없이 변경 및 종료될
                    수 있습니다.
                  </p>
                </div>
              </EventInfoNotice>
            </EventInfoNoticeWrapper>
            <EventPrizeWrapper>
              <div className="line" />
              <EventPrizeItem>
                <EventPrizeCircle>
                  {isCheck(20)}
                  <div className={`count ${users.length >= 20 ? "done" : ""}`}>
                    {users.length < 20 ? "20명" : "도달!"}
                  </div>
                </EventPrizeCircle>
                <div className="prize">
                  러너러너 마스크 100개, 카드 3덱
                  <br />
                  <span>(3만원 상당)</span>
                </div>
              </EventPrizeItem>
              <EventPrizeItem>
                <EventPrizeCircle>
                  {isCheck(50)}
                  <div className={`count ${users.length >= 50 ? "done" : ""}`}>
                    {users.length < 50 ? "50명" : "도달!"}
                  </div>
                </EventPrizeCircle>
                <div className="prize" style={{ marginTop: "-10px" }}>
                  러너러너 카드 2덱, 쿨토시 2개
                  <br />
                  손거울 3개, 핫팩 5개
                  <br />
                  <span>(5만원 상당)</span>
                </div>
              </EventPrizeItem>
              <EventPrizeItem>
                <EventPrizeCircle>
                  {isCheck(100)}
                  <div className={`count ${users.length >= 100 ? "done" : ""}`}>
                    {users.length < 100 ? "100명" : "도달!"}
                  </div>
                </EventPrizeCircle>
                <div className="prize" style={{ marginTop: "-10px" }}>
                  러너러너 카드 8덱, 머그컵 1개
                  <br />
                  쿠션 담요 1개, 무선거치대 1개
                  <br />
                  <span>(10만원 상당)</span>
                </div>
              </EventPrizeItem>
              <EventPrizeItem>
                <EventPrizeCircle>
                  {isCheck(150)}
                  <div className={`count ${users.length >= 150 ? "done" : ""}`}>
                    {users.length < 150 ? "150명" : "도달!"}
                  </div>
                </EventPrizeCircle>
                <div className="prize" style={{ marginTop: "-10px" }}>
                  러너러너 카드 10덱, 장우산 1개
                  <br />
                  보조배터리 1개
                  <br />
                  <span>(15만원 상당)</span>
                </div>
              </EventPrizeItem>
            </EventPrizeWrapper>
          </EventInfoWrapper>
        </EventDetailWrapper>
      </EventWrapper>
    </PageWrapper>
  );
};

export default Event;
